import createClient from '../../apolloClient';
import MUTATION_UPDATE_ESIM from '../../mutation/updateEsim';

const handleupdateEsim = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_UPDATE_ESIM,
    variables,
  });
  const { updateEsim } = result?.data || {};
  if (!updateEsim.isSuccess) throw updateEsim.message;
  return updateEsim;
};

export default handleupdateEsim;
